import {Link} from 'react-router-dom';
import {Button, Segment} from 'semantic-ui-react';
import ExamReportsList from './exam-reports-list';
import Fetcher from '../shared/fetches/fetcher';
import {fetchStudentExamReports} from '../../redux/actions/exam-report';

function ExamReportsListContainer() {
  return (
    <Fetcher
      action={fetchStudentExamReports}
      stateSelector={state => state.examReports}
      renderEmpty={renderEmpty}
    >
      {examReports => <ExamReportsList examReports={examReports}/>}
    </Fetcher>
  );
}

function renderEmpty() {
  return (
    <Segment textAlign='center'>
      <p>برای شما تاکنون نتیجه آزمونی ثبت نگردیده است.</p>
      <Button primary as={Link} to='/exam-report' content='ثبت نتیجه آزمون جدید'/>
    </Segment>
  );
}

export default ExamReportsListContainer;
